import React, { useState } from "react";
import Style from "./PeykRequest.module.css";
import { separate } from './../../../Functions/NumberSeprator';
import { useHistory } from "react-router-dom";
import { DeliveryRequestAccesptApi } from "../../../Api/DeliveryBarest";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBicycle } from "@fortawesome/free-solid-svg-icons";
const PeykRequest = ({ data }) => {
    const history = useHistory();
    const [loadingState, setLoadingState] = useState(false);
    const acceptHandler = () => {
      setLoadingState(true);
      let info = {
        id: data.id,
        action: "accept",
      };
      DeliveryRequestAccesptApi(info, (res) => {
        if (res.status === 1) {
          succToast("کاربر در مبدا منتظر شماست!");
          setTimeout(() => {
            setLoadingState(false);
            history.push("deliverypanel/ordercondition");
          }, 1000);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      });
    };
    
  return (
    <section className={Style.RequestSectionHolder}>
      <p className={Style.HeaderOfSection}>
        <span>درخواست پیک <FontAwesomeIcon icon={faBicycle}/></span>
        <span>شماره سفارش :{data?.id}</span>
         </p>
      <div className={Style.locationHolder}>
        <p>
          <span>مبدا:</span>
          {data?.delivery_routes[0]?.description}
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>مقصد:</span>
          {data?.delivery_routes[1]?.description}
        </p>
      </div>
      {data?.delivery_routes[2]&&<div className={Style.locationHolder}>
        <p>
          <span>مقصد دوم:</span>
          {data?.delivery_routes[2]?.description}
        </p>
      </div>}
      
      <div className={Style.locationHolder}>
        <p>
          <span>نوع وسیله:</span>
          {data?.category}
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span> مسافت حدودی:</span>
          {data?.distance} متر
        </p>
      </div>
      <div className={Style.locationHolder}>
        <p>
          <span>کرایه:</span>
          <strong style={{color:"green"}}>{separate(data?.delivery)} تومان</strong> 
        </p>
      </div>
      <button
        className={Style.AcceptButton}
        disabled={loadingState}
        onClick={acceptHandler}
      >
        {loadingState ? "منتظر باشید..." : "قبول درخواست"}
      </button>
    </section>
  );
};

export default PeykRequest;
